export default () => ({

    link:null,
    thisAlignmentElement:null,
    paddingToText: 40,
    videoElementWidth:null,
    videoElementHeight:null,
    
    init(){
        this.link = this.$el.querySelector('a[href="#video"]');
        this.thisAlignmentElement = this.$el;
        this.link.addEventListener('mouseenter',this.playVideo.bind(this),false)
        this.link.addEventListener('mouseleave',this.pauseVideo.bind(this),false)
        this.videoElementWidth = this.$refs.video.clientWidth
        this.videoElementHeight = this.$refs.video.clientHeight

        console.log('%c%s', 'color: #cc0036', 'Height',this.videoElementHeight);
        console.log('%c%s', 'color: #cc0036', 'Width',this.videoElementWidth);
        
    },

    pauseVideo(){
        this.$refs.video.pause()
        this.$refs.video.classList.add('opacity-0')
        
    },
    playVideo(){
        
        // Place the video element next to the text.
        this.$refs.video.style.left=`${this.thisAlignmentElement.offsetLeft - (this.videoElementWidth + this.paddingToText)}px` 

        // Center the video element in height
        this.$refs.video.style.top=`${this.link.offsetTop - (this.videoElementHeight/2)}px` 
        // this.$refs.video.style.left=`${this.thisAlignmentElement.offsetLeft + 150}px` 
        // this.$refs.video.style.top=`${this.thisAlignmentElement.offsetTop - 150}px` 
        this.$refs.video.classList.remove('opacity-0')
        this.$refs.video.play()
    }

});